
      import { createComponent } from '@lit/react'
      import { type EventName } from '@lit/react'
      import * as React from 'react'

      import Component from '../../components/tab/tab-group.component.js'
      import type { DdsTabSelectEvent } from '../../events/events'
      export type { DdsTabSelectEvent } from '../../events/events'

      const tagName = 'dap-ds-tab-group'

      /**
 * `dap-ds-tab-group`
 * @summary A tab group component. It is used with dap-ds-tab component to create a tab group.
 * @element dap-ds-tab-group
 * @title - Tab group
 * @group tab
 *
 * @event dds-tab-select - Fired when select a new tab.
 *
 * @slot - The tab items.
 *
 * @csspart base - The main container.
 * @csspart tab-nav - The tab navigation container.
 * @csspart tab-content - The tab content container.
 *
 * @cssproperty --dds-tab-group-border-radius - Border radius of the tab group container
 * @cssproperty --dds-tab-group-border-width - Border width of the tab navigation
 * @cssproperty --dds-tab-group-border-color - Border color of the tab navigation
 * @cssproperty --dds-tab-height-sm - Height of small tabs
 * @cssproperty --dds-tab-height-lg - Height of large tabs
 * @cssproperty --dds-tab-font-size-sm - Font size of small tabs
 * @cssproperty --dds-tab-font-size-lg - Font size of large tabs
 * @cssproperty --dds-tab-padding - Padding of the tab buttons
 * @cssproperty --dds-tab-border-width - Border width for tabs
 * @cssproperty --dds-tab-selected-border-color - Border color for selected tabs
 * @cssproperty --dds-tab-text-color - Text color for tabs
 * @cssproperty --dds-tab-hover-text-color - Text color for tabs on hover
 * @cssproperty --dds-tab-disabled-text-color - Text color for disabled tabs
 * @cssproperty --dds-tab-hover-background - Background color for tabs on hover
 * @cssproperty --dds-tab-active-background - Background color for active tabs
 */
      const reactWrapper = createComponent({
        tagName,
        elementClass: Component,
        react: React,
        events: {
          onDdsTabSelect: 'dds-tab-select' as EventName<DdsTabSelectEvent>
        },
        displayName: "DapDSTabGroup"
      })

      export default reactWrapper
    